import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesSaunaComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Person seated on the bench, side profile */}
        <circle cx="8.5" cy="5" fill="currentColor" r="1.75" stroke="none" />
        <path d="M8.5 8.5v5.5h5v4.5" />
        <path d="M8.5 11h3" />
        {/* Bench */}
        <path d="M4 18.5h16" />
        {/* Rising steam */}
        <path d="M17 4.5c1 1 1 2 0 3s1 2 0 3" />
        <path d="M20.5 4.5c1 1 1 2 0 3s1 2 0 3" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesSaunaComponent.displayName = 'IconAmenitiesSauna';

const IconAmenitiesSauna = React.memo(IconAmenitiesSaunaComponent);

export default IconAmenitiesSauna;
